(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      if (isNaN(number) || number == null) {
        return '0';
      }

      number = (number / 100).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );

      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) {
      return (cents / 100).toFixed(2);
    }

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;

      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;

      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function initBuyTogether(root) {
    if (!root || root.dataset.fbtInitialized === 'true') {
      return;
    }

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-fbt-slide]')
    );

    if (!slides.length) {
      return;
    }

    root.dataset.fbtInitialized = 'true';

    var track = root.querySelector('[data-fbt-track]');
    var prev = root.querySelector('[data-fbt-prev]');
    var next = root.querySelector('[data-fbt-next]');
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-fbt-dot]')
    );

    var addButton = root.querySelector('[data-fbt-add]');
    var buttonText = root.querySelector('[data-fbt-button-text]');
    var loader = root.querySelector('.od-fbt__loader');

    var totalElement = root.querySelector('[data-fbt-total]');
    var compareElement = root.querySelector('[data-fbt-compare]');

    var dataElement = root.querySelector('[data-fbt-data]');

    if (!track || !addButton || !dataElement) {
      return;
    }

    var config;

    try {
      config = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Buy Together: invalid JSON config.', error);
      return;
    }

    var currentIndex = 0;
    var touchStartX = 0;

    function getCurrentVariantId() {
      var mainForm =
        document.querySelector(
          '#product-form-' + root.dataset.sectionId + ' input[name="id"]'
        ) ||
        document.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );

      if (mainForm && mainForm.value) {
        return parseInt(mainForm.value, 10);
      }

      return parseInt(config.currentVariantId, 10);
    }

    function getCurrentPrice() {
      var currentPriceElement = root.querySelector(
        '[data-fbt-current-price]'
      );

      if (currentPriceElement && currentPriceElement.dataset.price) {
        return parseInt(currentPriceElement.dataset.price, 10);
      }

      return parseInt(config.currentPrice, 10);
    }

    function getCandidate() {
      return slides[currentIndex];
    }

    function updateTotals() {
      var candidate = getCandidate();

      if (!candidate) {
        return;
      }

      var currentPrice = getCurrentPrice();
      var candidatePrice = parseInt(candidate.dataset.price, 10) || 0;

      var originalTotal = currentPrice + candidatePrice;
      var discount = parseFloat(config.discount) || 0;

      var discountedTotal = Math.round(
        originalTotal * (100 - discount) / 100
      );

      compareElement.textContent = formatMoney(
        originalTotal,
        config.moneyFormat
      );

      totalElement.textContent = formatMoney(
        discountedTotal,
        config.moneyFormat
      );
    }

    function goTo(index) {
      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;

      track.style.transform =
        'translate3d(-' + currentIndex * 100 + '%, 0, 0)';

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
      });

      updateTotals();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goTo(index);
      });
    });

    track.addEventListener(
      'touchstart',
      function (event) {
        touchStartX = event.touches[0].clientX;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchend',
      function (event) {
        var touchEndX = event.changedTouches[0].clientX;
        var difference = touchStartX - touchEndX;

        if (Math.abs(difference) < 40) {
          return;
        }

        if (difference > 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      },
      { passive: true }
    );

    addButton.addEventListener('click', function () {
      var candidate = getCandidate();

      if (!candidate || addButton.disabled) {
        return;
      }

      var currentVariantId = getCurrentVariantId();
      var candidateVariantId = parseInt(
        candidate.dataset.variantId,
        10
      );

      if (!currentVariantId || !candidateVariantId) {
        return;
      }

      var fbtId =
        'fbt-' +
        Date.now() +
        '-' +
        Math.random().toString(36).slice(2, 9);

      function properties(role) {
        return {
          '_fbt_id': fbtId,
          '_bundle_type': 'fbt',
          '_role': role
        };
      }

      addButton.disabled = true;

      if (loader) {
        loader.hidden = false;
      }

      if (buttonText) {
        buttonText.style.opacity = '0.6';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: currentVariantId,
              quantity: 1,
              properties: properties('parent')
            },
            {
              id: candidateVariantId,
              quantity: 1,
              properties: properties('addon')
            }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }

          return response.json();
        })
        .then(function () {
          var cartDrawer = document.querySelector('cart-drawer');

          if (cartDrawer && typeof cartDrawer.open === 'function') {
            return fetch(
              window.Shopify.routes.root +
                '?sections=cart-drawer,cart-icon-bubble'
            )
              .then(function (response) {
                return response.json();
              })
              .then(function (sections) {
                var drawerSection = sections['cart-drawer'];
                var bubbleSection = sections['cart-icon-bubble'];

                if (drawerSection) {
                  var parser = new DOMParser();
                  var drawerDocument = parser.parseFromString(
                    drawerSection,
                    'text/html'
                  );

                  var newDrawer =
                    drawerDocument.querySelector('cart-drawer');

                  if (newDrawer) {
                    cartDrawer.innerHTML = newDrawer.innerHTML;
                  }
                }

                if (bubbleSection) {
                  var parserBubble = new DOMParser();
                  var bubbleDocument = parserBubble.parseFromString(
                    bubbleSection,
                    'text/html'
                  );

                  var newBubble =
                    bubbleDocument.querySelector('#cart-icon-bubble');

                  var currentBubble =
                    document.querySelector('#cart-icon-bubble');

                  if (newBubble && currentBubble) {
                    currentBubble.innerHTML = newBubble.innerHTML;
                  }
                }

                cartDrawer.open();
              });
          }

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true
            })
          );
        })
        .catch(function (error) {
          console.error('Buy Together add to cart error:', error);
        })
        .finally(function () {
          addButton.disabled = false;

          if (loader) {
            loader.hidden = true;
          }

          if (buttonText) {
            buttonText.style.opacity = '';
          }
        });
    });

    currentIndex = 0;

    dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === 0);
    });
  }

    function initAllBuyTogether() {
        document.querySelectorAll('[data-fbt]').forEach(initBuyTogether);
    }

    function initProductStickyBar() {
        const stickyBar = document.querySelector('[data-product-sticky-bar]');
        const mainAddButton = document.querySelector(
            '.product-redesign__buy .product-form__submit'
        );
        const footer = document.querySelector('.new__footer');

        if (!stickyBar || !mainAddButton) {
            return;
        }

        // Не ініціалізуємо повторно
        if (stickyBar.dataset.stickyInitialized === 'true') {
            return;
        }

        stickyBar.dataset.stickyInitialized = 'true';

        const stickyAddButton = stickyBar.querySelector('[data-sticky-add]');

        let mainAddButtonPassed = false;
        let footerVisible = false;

        function updateStickyBar() {
            const shouldShow = mainAddButtonPassed && !footerVisible;

            stickyBar.classList.toggle('is-visible', shouldShow);
            stickyBar.setAttribute('aria-hidden', String(!shouldShow));
        }

        if (stickyAddButton) {
            stickyAddButton.addEventListener('click', function () {
                if (mainAddButton.disabled) {
                    return;
                }

                mainAddButton.click();
            });
        }

        // Показуємо sticky bar тільки після того,
        // як основна Add to cart пішла вище viewport
        const mainButtonObserver = new IntersectionObserver(
            function (entries) {
                const entry = entries[0];

                mainAddButtonPassed =
                    !entry.isIntersecting &&
                    entry.boundingClientRect.bottom < 0;

                updateStickyBar();
            },
            {
                threshold: 0
            }
        );

        mainButtonObserver.observe(mainAddButton);

        // Якщо на сторінці є footer —
        // приховуємо sticky bar, коли footer входить у viewport
        if (footer) {
            const footerObserver = new IntersectionObserver(
                function (entries) {
                    footerVisible = entries[0].isIntersecting;

                    updateStickyBar();
                },
                {
                    threshold: 0
                }
            );

            footerObserver.observe(footer);
        }
    }

    function initProductRedesign() {
    initAllBuyTogether();
    initProductStickyBar();
    }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRedesign);
    } else {
    initProductRedesign();
    }

    document.addEventListener('shopify:section:load', function () {
    initProductRedesign();
  });

})();